import React from 'react';
import { formLabelClassName } from './formStyles';

function Label({ children, htmlFor, className = '', required = false, ...props }) {
  return (
    <label htmlFor={htmlFor} className={`${formLabelClassName} ${className}`.trim()} {...props}>
      {children}
      {required ? <span className="ml-0.5 text-error-500">*</span> : null}
    </label>
  );
}

export default Label;
